<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <mask
      id="mask0_14552_784"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_14552_784)">
      <path
        d="M15.8848 5.87858C16.4076 6.66095 16.4076 7.75007 16.4076 9.92832C16.4076 12.1066 16.4076 13.1957 15.8848 13.9781C15.6585 14.3168 15.3677 14.6076 15.029 14.8339C14.3455 15.2906 13.428 15.3483 11.7547 15.3556V15.3566L10.8974 17.0713C10.6116 17.6429 9.79597 17.6429 9.51019 17.0713L8.65285 15.3566V15.3556C6.9796 15.3483 6.06204 15.2906 5.37858 14.8339C5.03988 14.6076 4.74907 14.3168 4.52276 13.9781C4 13.1957 4 12.1066 4 9.92832C4 7.75007 4 6.66095 4.52276 5.87858C4.74907 5.53988 5.03988 5.24907 5.37858 5.02276C6.16095 4.5 7.25007 4.5 9.42832 4.5H10.9793C13.1575 4.5 14.2466 4.5 15.029 5.02276C15.3677 5.24907 15.6585 5.53988 15.8848 5.87858Z"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
      <path
        d="M8.37891 8.37744L13.0318 8.37744"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
      <path
        d="M9.47461 11.4795H11.801"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
